import { AgentStage } from "@flypengine/myFlyp-lib"
import { pipe } from "fp-ts/lib/function"
import * as O from "fp-ts/Option"

export function numberAbreviation(number: number): {
  value: number
  name: O.Option<"M" | "k">
} {
  const truncated = Math.floor(number * 100) / 100

  if (Number.isNaN(truncated)) {
    throw new TypeError("Invalid Number")
  }

  if (truncated >= 1000000) {
    return {
      value: Number((truncated / 1000000).toFixed(2)),
      name: O.some("M"),
    }
  }

  if (truncated >= 1000) {
    return {
      value: Number((truncated / 1000).toFixed(1)),
      name: O.some("k"),
    }
  }
  return {
    value: Number(truncated.toFixed(1)),
    name: O.none,
  }
}

export const percentNumber = (value: number, precision: number): string => {
  if (!Number.isNaN(value)) {
    return (value * 100).toFixed(precision)
  } else {
    throw new TypeError("Invalid Number")
  }
}

export const ordinalNumber = (number: number) => {
  const rule = new Intl.PluralRules("en-GB", { type: "ordinal" })

  const suffixes = new Map([
    ["one", "st"],
    ["two", "nd"],
    ["few", "rd"],
    ["other", "th"],
  ])

  return `${number}${suffixes.get(rule.select(number))}`
}

export const agentName = ({
  brand,
  branch,
}: {
  brand: string
  branch: O.Option<string>
}): string =>
  pipe(
    branch,
    O.match(
      () => brand,
      branch => (branch.length ? `${brand} ${branch}` : brand)
    )
  )

export const agentStage = (stage: AgentStage): string => {
  switch (stage) {
    case "valuationSent":
      return "Valuation Sent"
    case "valuationReceived":
      return "Valuation Received"
    case "instructionSent":
      return "Instruction Sent"
    case "instructionDownloaded":
      return "Instruction Downloaded"
    case "viewings":
      return "Booking Viewings"
    case "publishedOnAgentWebsite":
      return "On Agent Website"
    case "offer":
      return "Receiving offers"
  }
}
